import {PageTitle} from '../../../_metronic/layout/core';
import {useIntl} from 'react-intl';
import Services from '../Components/Services';
import {useQuery} from 'react-query';
import {ListService} from '../Types/service';
import {getServicesByClient} from '../Api/api';
import {useGetMe} from '../../../app/hooks/useGetMe';
import {isClientCIS} from '../../Auth/Utils/CustomerHelper';
import ComingSoon from '../../../app/common/components/ComingSoon';

const VpnPage = (): JSX.Element => {
  const intl = useIntl();
  const customer = useGetMe();
  const {isLoading, data: services} = useQuery<ListService[]>(['get-service-by-client-vpn'], () =>
    getServicesByClient('VPN')
  );

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.CONNECTIONS'})}</PageTitle>
      {isClientCIS(customer) ? (
        <Services
          isLoading={isLoading}
          services={services}
          title={intl.formatMessage({id: 'MENU.CONNECTIONS.VPN'})}
          enableRowDetail
          showTypeFilter={false}
          detailRoute={(service) => `/services/connexion/vpn/${service.serviceId}`}
          enableSubServices
        />
      ) : (
        <ComingSoon />
      )}
    </>
  );
};

export default VpnPage;
